// Rows a self-fetching workspace list is actually showing, in on-screen order.
//
// Some list panels (e.g. WorkspacePropertyList for the engagement list) fetch their own data, so the
// tool payload in `latestCards.records` can differ from — or be empty next to — what the user sees.
// SAM's navigate_cards ("open the 3rd one", "next") must count the rows the USER sees, so such lists
// publish them here and useChatWorkspace.onNavigateCards reads them.

export interface VisibleRow {
  /** Record id opened in the module's detail (property_id for the engagement list). */
  id: string;
  /** Specific engagement to show inside that detail, when the row is one engagement. */
  engagementId?: string;
}

const rows: Partial<Record<string, VisibleRow[]>> = {};

export function setVisibleRows(module: string, list: VisibleRow[] | null): void {
  if (list) rows[module] = list;
  else delete rows[module];
}

export function getVisibleRows(module: string): VisibleRow[] | undefined {
  return rows[module];
}
